import { Subscription } from './Subscription';
import { SubscriptionPlan } from './enums/SubscriptionPlan';

/**
 * Checks if the user is considered a paid customer.
 * A user is a paid customer if they are on a paid plan (not Demo/Unregistered)
 * OR if they have purchased extra credits (even if on a Demo plan).
 */
export const isPaidCustomer = (subscription: Subscription | null | undefined): boolean => {
    if (!subscription) {
        return false;
    }

    const { plan, extraCredits } = subscription;
    const isDemoOrUnregistered = plan === SubscriptionPlan.Demo || plan === SubscriptionPlan.UnregisteredUser;
    const hasExtraCredits = (extraCredits ?? 0) > 0;

    // Paid customer if NOT demo/unregistered OR has extra credits
    return !isDemoOrUnregistered || hasExtraCredits;
};

